import React, { useState, useImperativeHandle, useEffect } from 'react';
import { Row, Col, Form, Radio, Typography, ColorPicker } from 'antd';

import expandedIcon from '../../../assets/icons/expanded/01.svg';
import iconIcon from '../../../assets/icons/icon/01.svg';

import './styles.css'

function CategoryForm(props, ref) {
    const [form] = Form.useForm();
    const [display, setDisplay] = useState(undefined);
    const [fontColor, setFontColor] = useState('#ffffff');

    useEffect(() => {
    }, []);

    useImperativeHandle(ref, () => ({
        getFieldsValue: () => {
            var formValues = form.getFieldsValue();
            return {
                display,
                fontColor,
                columns: formValues.columns
            };
        },
        onLoadDefault: () => {
            setDisplay(1);
            setFontColor('#ffffff');
            form.setFieldsValue({
                columns: 4
            });
        },
        onLoad: (data) => {
            setDisplay(data?.display);
            setFontColor(data?.fontColor ?? '#ffffff');
            data.columns = data.columns ? data.columns : 4;
            form.setFieldsValue(data);
        },
    }));

    const options = [
        { label: 1, value: 1, },
        { label: 2, value: 2, },
        { label: 3, value: 3, },
        { label: 4, value: 4, },
        { label: 6, value: 6, },
        { label: 12, value: 12, },
    ];

    return (
        <Form
            form={form}
            layout="vertical"
        >
            <Row gutter={20} className='mt-10'>
                <Col span={24} className='mb-10'>
                    <Typography.Title level={5} className='mt-0'>
                        Modo de Visualización
                    </Typography.Title>
                </Col>

                <Col span={8}>
                    <div
                        className={`category-display-mode vertical-center horizontal-center ` + (display === undefined ? '' : display == 1 ? 'active' : '')}
                        onClick={() => {
                            if (display !== 1)
                                setDisplay(1);
                        }}
                    >
                        <div className='text-center'>
                            <img src={iconIcon} alt="" />
                            <div className='mt-10'>
                                Icono
                            </div>
                            <Radio
                                value={1}
                                className='ml-10'
                                checked={display === undefined ? false : display == 1 ? true : false}
                            />
                        </div>
                    </div>
                </Col>
                <Col span={8}>
                    <div
                        className={`category-display-mode vertical-center horizontal-center ` + (display === undefined ? '' : display == 2 ? 'active' : '')}
                        onClick={() => {
                            if (display !== 2)
                                setDisplay(2);
                        }}
                    >
                        <div className='text-center'>
                            <img src={expandedIcon} alt="" />
                            <div className='mt-10'>
                                Expandido
                            </div>
                            <Radio
                                value={2}
                                className='ml-10'
                                checked={display === undefined ? false : display == 2 ? true : false}
                            />
                        </div>
                    </div>
                </Col>

                <Col span={24} className='mb-10 mt-30'>
                    <Typography.Title level={5} className='mt-0'>
                        Distribución de Columnas
                    </Typography.Title>
                </Col>

                <Col span={24}>
                    <Form.Item noStyle name="columns">
                        <Radio.Group
                            size='large'
                            options={options}
                            // defaultValue={4}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </Form.Item>
                </Col>


                <Col span={24} className='mb-10 mt-30'>
                    <Typography.Title level={5} className='mt-0'>
                        Color de fuente
                    </Typography.Title>
                </Col>

                <Col span={24}>
                    <ColorPicker
                        showText
                        size="large"
                        value={fontColor}
                        onChange={(target, value) => setFontColor(value)}
                    />
                </Col>
            </Row>
        </Form>
    )
}
export default React.forwardRef(CategoryForm);